import type { Transaction } from '@app/shared';

/** Un guillemet double s'échappe en le doublant (RFC 4180) ; toujours entre guillemets. */
function csvCell(value: string): string {
  return `"${value.replace(/"/g, '""')}"`;
}

export function transactionsToCsv(
  rows: readonly Transaction[],
  propertyNames: ReadonlyMap<number, string>,
  categoryLabels: ReadonlyMap<number, string>,
): string {
  const header = ['Date', 'Libellé', 'Montant (centimes)', 'Bien', 'Catégorie', 'Statut'].map(csvCell).join(';');
  const lines = rows.map((row) =>
    [
      row.txDate,
      row.label,
      String(row.amountCents),
      row.propertyId === null ? '' : (propertyNames.get(row.propertyId) ?? String(row.propertyId)),
      row.categoryId === null ? '' : (categoryLabels.get(row.categoryId) ?? String(row.categoryId)),
      row.status,
    ]
      .map(csvCell)
      .join(';'),
  );
  return [header, ...lines].join('\r\n');
}

/** Le ledger est en centimes signés : jamais de flottant, même à l'export. */
export function downloadCsv(fileName: string, content: string): void {
  const blob = new Blob(['﻿', content], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = fileName;
  link.click();
  URL.revokeObjectURL(url);
}
